import * as Data$dTuple from "../Data.Tuple/index.js";
const $Codec = (_1, _2) => ({tag: "Codec", _1, _2});
const Codec = value0 => value1 => $Codec(value0, value1);
const profunctorCodec = dictFunctor => (
  {
    dimap: f => g => v => $Codec(
      (() => {
        const $0 = dictFunctor.map(g);
        return x => $0(v._1(x));
      })(),
      x => {
        const $0 = v._2(f(x));
        return Data$dTuple.$Tuple($0._1, g($0._2));
      }
    )
  }
);
const functorCodec = dictFunctor => (
  {
    map: f => v => $Codec(
      (() => {
        const $0 = dictFunctor.map(f);
        return x => $0(v._1(x));
      })(),
      x => {
        const $0 = v._2(x);
        return Data$dTuple.$Tuple($0._1, f($0._2));
      }
    )
  }
);
const invariantCodec = dictFunctor => (
  {
    imap: f => v => v$1 => $Codec(
      (() => {
        const $0 = dictFunctor.map(f);
        return x => $0(v$1._1(x));
      })(),
      x => {
        const $0 = v$1._2(x);
        return Data$dTuple.$Tuple($0._1, f($0._2));
      }
    )
  }
);
const applyCodec = dictApply => {
  const $0 = dictApply.Functor0();
  const functorCodec1 = {
    map: f => v => $Codec(
      (() => {
        const $1 = $0.map(f);
        return x => $1(v._1(x));
      })(),
      x => {
        const $1 = v._2(x);
        return Data$dTuple.$Tuple($1._1, f($1._2));
      }
    )
  };
  return dictSemigroup => (
    {apply: v => v1 => $Codec(a => dictApply.apply(v._1(a))(v1._1(a)), c => Data$dTuple.applyTuple(dictSemigroup).apply(v._2(c))(v1._2(c))), Functor0: () => functorCodec1}
  );
};
const applicativeCodec = dictApplicative => {
  const applyCodec1 = applyCodec(dictApplicative.Apply0());
  return dictMonoid => {
    const applyCodec2 = applyCodec1(dictMonoid.Semigroup0());
    return {
      pure: x => $Codec(
        (() => {
          const $0 = dictApplicative.pure(x);
          return v => $0;
        })(),
        (() => {
          const $0 = Data$dTuple.applicativeTuple(dictMonoid).pure(x);
          return v => $0;
        })()
      ),
      Apply0: () => applyCodec2
    };
  };
};
const altCodec = dictAlt => {
  const $0 = dictAlt.Functor0();
  const functorCodec1 = {
    map: f => v => $Codec(
      (() => {
        const $1 = $0.map(f);
        return x => $1(v._1(x));
      })(),
      x => {
        const $1 = v._2(x);
        return Data$dTuple.$Tuple($1._1, f($1._2));
      }
    )
  };
  return {alt: v => v1 => $Codec(a => dictAlt.alt(v._1(a))(v1._1(a)), v1._2), Functor0: () => functorCodec1};
};
const hoist = f => v => $Codec(x => f(v._1(x)), v._2);
const encode = v => x => v._2(x)._1;
const decode = v => v._1;
const compose = dictBind => v => v1 => {
  const $0 = v._1;
  return $Codec(
    a => dictBind.bind(v1._1(a))($0),
    x => {
      const $1 = v._2(x);
      return Data$dTuple.$Tuple(v1._2($1._1)._1, $1._2);
    }
  );
};
const composeFlipped = dictBind => b => a => {
  const $0 = a._1;
  return $Codec(
    a$1 => dictBind.bind(b._1(a$1))($0),
    x => {
      const $1 = a._2(x);
      return Data$dTuple.$Tuple(b._2($1._1)._1, $1._2);
    }
  );
};
const codec$p = f => g => $Codec(f, b => Data$dTuple.$Tuple(g(b), b));
const codec = f => g => $Codec(f, b => Data$dTuple.$Tuple(g(b), b));
const fix = f => $Codec(x => f(fix(f))._1(x), b => Data$dTuple.$Tuple(f(fix(f))._2(b)._1, b));
const identity = dictApplicative => $Codec(dictApplicative.pure, b => Data$dTuple.$Tuple(b, b));
export {
  $Codec,
  Codec,
  altCodec,
  applicativeCodec,
  applyCodec,
  codec,
  codec$p,
  compose,
  composeFlipped,
  decode,
  encode,
  fix,
  functorCodec,
  hoist,
  identity,
  invariantCodec,
  profunctorCodec
};
